import { render } from "./ck_editer.vue?vue&type=template&id=056179e6"
import script from "./ck_editer.vue?vue&type=script&lang=js"
export * from "./ck_editer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__